import { useState, useEffect } from 'react';

function ConfirmDeleteModal({
  open,
  name,
  onClose,
  onConfirm,
  description,
  isDeleting,
  title,
}) {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    if (open) {
      setTyped('');
    }
  }, [open]);

  // Safely handle name prop in case it's not a string
  const targetName = String(name || '').trim();
  const canDelete = typed.trim() === targetName;

  if (!open) return null;
  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-black/40"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="w-full max-w-md rounded-lg bg-white shadow-xl">
          <div className="border-b px-4 py-3">
            <h3 className="text-base font-semibold">
              {title || 'Delete object'}
            </h3>
          </div>
          <form onLoad={(e) => e.preventDefault()}>
            <div className="space-y-3 px-4 py-4">
              <p className="text-sm text-gray-700">
                {description}:{' '}
                <span className="font-mono font-semibold">{name}</span>
              </p>
              <input
                autoFocus
                value={typed}
                onChange={(e) => setTyped(e.target.value)}
                className="w-full rounded border border-gray-300 px-3 py-2 text-sm outline-none focus:border-red-500 focus:ring-2 focus:ring-red-200"
                placeholder={name}
              />
            </div>
            <div className="flex justify-end gap-2 border-t px-4 py-3">
              <button
                onClick={onClose}
                className="rounded border border-gray-300 px-3 py-2 text-sm hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={!canDelete}
                onClick={(e) => {
                  e.preventDefault();
                  onConfirm();
                }}
                className={`rounded px-3 py-2 text-sm text-white ${
                  canDelete
                    ? 'bg-red-600 hover:bg-red-700'
                    : 'bg-red-300 cursor-not-allowed'
                }`}
              >
                {isDeleting ? 'Deleting...' : 'Delete'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default ConfirmDeleteModal;
